import { Routes, Route } from "react-router-dom";
/* Attachment Form */
import { OSCI0203017S } from "@/tz/go/egaz/osci/lpco/cfgn/atcm/OSCI0203017S";
import { OSCI0203018Q } from "@/tz/go/egaz/osci/lpco/cfgn/atcm/OSCI0203018Q";
import { OSCI0203019S } from "@/tz/go/egaz/osci/lpco/cfgn/atcm/OSCI0203019S";
import { OSCI0203020S } from "@/tz/go/egaz/osci/lpco/cfgn/atcm/OSCI0203020S";
/* Component */
import { OSCI0203001S } from "@/tz/go/egaz/osci/lpco/cfgn/cpnt/OSCI0203001S";
import { OSCI0203002Q } from "@/tz/go/egaz/osci/lpco/cfgn/cpnt/OSCI0203002Q";
import { OSCI0203003S } from "@/tz/go/egaz/osci/lpco/cfgn/cpnt/OSCI0203003S";
import { OSCI0203004S } from "@/tz/go/egaz/osci/lpco/cfgn/cpnt/OSCI0203004S";
/* Process */
import { OSCI0203009S } from "@/tz/go/egaz/osci/lpco/cfgn/prcs/OSCI0203009S";
import { OSCI0203010Q } from "@/tz/go/egaz/osci/lpco/cfgn/prcs/OSCI0203010Q";
import { OSCI0203011S } from "@/tz/go/egaz/osci/lpco/cfgn/prcs/OSCI0203011S";
import { OSCI0203012S } from "@/tz/go/egaz/osci/lpco/cfgn/prcs/OSCI0203012S";
/* Assignment */
import { OSCI0203013S } from "@/tz/go/egaz/osci/lpco/cfgn/asin/OSCI0203013S";
import { OSCI0203014Q } from "@/tz/go/egaz/osci/lpco/cfgn/asin/OSCI0203014Q";
import { OSCI0203015S } from "@/tz/go/egaz/osci/lpco/cfgn/asin/OSCI0203015S";
import { OSCI0203016S } from "@/tz/go/egaz/osci/lpco/cfgn/asin/OSCI0203016S";

/* Additional Item */
import { OSCI0203005S } from "@/tz/go/egaz/osci/lpco/cfgn/adtnlitm/OSCI0203005S";
import { OSCI0203006Q } from "@/tz/go/egaz/osci/lpco/cfgn/adtnlitm/OSCI0203006Q";
import { OSCI0203007S } from "@/tz/go/egaz/osci/lpco/cfgn/adtnlitm/OSCI0203007S";
import { OSCI0203008S } from "@/tz/go/egaz/osci/lpco/cfgn/adtnlitm/OSCI0203008S";

/* Officer Additional Item */
import { OSCI0203033S } from "@/tz/go/egaz/osci/lpco/cfgn/ofcradtnlitm/OSCI0203033S";
import { OSCI0203034Q } from "@/tz/go/egaz/osci/lpco/cfgn/ofcradtnlitm/OSCI0203034Q";
import { OSCI0203035S } from "@/tz/go/egaz/osci/lpco/cfgn/ofcradtnlitm/OSCI0203035S";
import { OSCI0203036S } from "@/tz/go/egaz/osci/lpco/cfgn/ofcradtnlitm/OSCI0203036S";

/* Fee Settings */
import { OSCI0203021S } from "@/tz/go/egaz/osci/lpco/cfgn/fee/OSCI0203021S";
import { OSCI0203022Q } from "@/tz/go/egaz/osci/lpco/cfgn/fee/OSCI0203022Q";
import { OSCI0203023S } from "@/tz/go/egaz/osci/lpco/cfgn/fee/OSCI0203023S";
import { OSCI0203024S } from "@/tz/go/egaz/osci/lpco/cfgn/fee/OSCI0203024S";

/* Department and Officer in Charge Settings */
import { OSCI0203025S } from "@/tz/go/egaz/osci/lpco/cfgn/chpn/OSCI0203025S";
import { OSCI0203026Q } from "@/tz/go/egaz/osci/lpco/cfgn/chpn/OSCI0203026Q";
import { OSCI0203027S } from "@/tz/go/egaz/osci/lpco/cfgn/chpn/OSCI0203027S";
import { OSCI0203028S } from "@/tz/go/egaz/osci/lpco/cfgn/chpn/OSCI0203028S";

/* HS Code Settings */
import { OSCI0203029S } from "@/tz/go/egaz/osci/lpco/cfgn/hscd/OSCI0203029S";
import { OSCI0203030Q } from "@/tz/go/egaz/osci/lpco/cfgn/hscd/OSCI0203030Q";
import { OSCI0203031S } from "@/tz/go/egaz/osci/lpco/cfgn/hscd/OSCI0203031S";
import { OSCI0203032S } from "@/tz/go/egaz/osci/lpco/cfgn/hscd/OSCI0203032S";

/*
 * 응용기능별 Router
 * - 명명규칙 : 응용기능 2 레벨 메타 단어(용어) 카멜표기(첫글자 대문자) + Router
 * - 응용기능 2 레벨 별로 Router 분리 원칙(기본)
 * - 응용기능 레벨별로 소문자로 구분하여 경로 작성
 * - 최종 라우팅하는 주소는 화면 아이디에서 '-' 구분자를 빼고 소문자로 변환하여 작성
 * - element 에 해당 화면 컴포넌트 기입
 * - 화면에서 파라메터로 받아서 사용할 키값은 path 문자열에 ':변수명' 으로 기입하여 해당 컴포넌트 인지하여 사용
 */

export const OsciLpcoCfgnRouter = () => {
    return (
        <Routes>
            {/* Register Component !== Component 등록 ==! */}
            <Route path="/cpnt/osci0203001s" element={<OSCI0203001S />} />
            {/* Component List !== Component 목록 ==! */}
            <Route path="/cpnt/osci0203002q" element={<OSCI0203002Q />} />
            {/* Component Detail !== Component 상세 ==! */}
            <Route path="/cpnt/osci0203003s/:appFmId" element={<OSCI0203003S />} />
            {/* Component Modification !== Component 수정 ==! */}
            <Route path="/cpnt/osci0203004s/:appFmId" element={<OSCI0203004S />} />

            {/* Addtional Item Registration !== Addtional Item 등록 ==! */}
            <Route path="/adtnlitm/osci0203005s" element={<OSCI0203005S />} />
            {/* Addtional Item List !== Addtional Item 목록 ==! */}
            <Route path="/adtnlitm/osci0203006q" element={<OSCI0203006Q />} />
            {/* Addtional Item Detail !== Addtional Item 상세 ==! */}
            <Route path="/adtnlitm/osci0203007s/:appFmId" element={<OSCI0203007S />} />
            {/* Addtional Item Modification !== Addtional Item 수정 ==! */}
            <Route path="/adtnlitm/osci0203008s/:appFmId" element={<OSCI0203008S />} />

            {/* Officer Addtional Item Registration !== Officer Addtional Item 등록 ==! */}
            <Route path="/ofcradtnlitm/osci0203033s" element={<OSCI0203033S />} />
            {/* Officer Addtional Item List !== Officer Addtional Item 목록 ==! */}
            <Route path="/ofcradtnlitm/osci0203034q" element={<OSCI0203034Q />} />
            {/* Officer Addtional Item Detail !== Officer Addtional Item 상세 ==! */}
            <Route path="/ofcradtnlitm/osci0203035s/:appFmId" element={<OSCI0203035S />} />
            {/* Officer Addtional Item Modification !== Officer Addtional Item 수정 ==! */}
            <Route path="/ofcradtnlitm/osci0203036s/:appFmId" element={<OSCI0203036S />} />

            {/* Register Process !== Process 등록 ==! */}
            <Route path="/prcs/osci0203009s" element={<OSCI0203009S />} />
            {/* Process List !== Process 목록 ==! */}
            <Route path="/prcs/osci0203010q" element={<OSCI0203010Q />} />
            {/* Process Detail !== Process 상세 ==! */}
            <Route path="/prcs/osci0203011s/:prcsMnId" element={<OSCI0203011S />} />
            {/* Process Modification !== Process 수정 ==! */}
            <Route path="/prcs/osci0203012s/:prcsMnId" element={<OSCI0203012S />} />

            {/* Register Assignment Criteria !==  Assignment Criteria 등록 ==! */}
            <Route path="/asin/osci0203013s" element={<OSCI0203013S />} />
            {/*  Assignment Criteria List !==  Assignment Criteria 목록 ==! */}
            <Route path="/asin/osci0203014q" element={<OSCI0203014Q />} />
            {/*  Assignment Criteria Detail !==  Assignment Criteria 상세 ==! */}
            <Route path="/asin/osci0203015s/:appFmId" element={<OSCI0203015S />} />
            {/*  Assignment Criteria Modification !== Process 수정 ==! */}
            <Route path="/asin/osci0203016s/:appFmId" element={<OSCI0203016S />} />

            {/* Attachment Registration !== Attachment 등록 ==! */}
            <Route path="/atcm/osci0203017s" element={<OSCI0203017S />} />
            {/* Attachment List !== Attachment 목록 ==! */}
            <Route path="/atcm/osci0203018q" element={<OSCI0203018Q />} />
            {/* Attachment Detail !== Attachment 상세 ==! */}
            <Route path="/atcm/osci0203019s/:appFmId" element={<OSCI0203019S />} />
            {/* Attachment Modification !== Attachment 수정 ==! */}
            <Route path="/atcm/osci0203020s/:appFmId" element={<OSCI0203020S />} />

            {/* Fee Registration !== Fee 등록 ==! */}
            <Route path="/fee/osci0203021s" element={<OSCI0203021S />} />
            {/* Fee List !== Fee 목록 ==! */}
            <Route path="/fee/osci0203022q" element={<OSCI0203022Q />} />
            {/* Fee Detail !== Fee 상세 ==! */}
            <Route path="/fee/osci0203023s/:feeImpsCtraId" element={<OSCI0203023S />} />
            {/* Fee Modification !== Fee 수정 ==! */}
            <Route path="/fee/osci0203024s/:feeImpsCtraId" element={<OSCI0203024S />} />

            {/* Contact person registration!== 담당자 등록 ==! */}
            <Route path="/chpn/osci0203025s" element={<OSCI0203025S />} />
            {/* Contact person List !== 담당자 목록 ==! */}
            <Route path="/chpn/osci0203026q" element={<OSCI0203026Q />} />
            {/* Contact person Detail !== 담당자 상세 ==! */}
            <Route path="/chpn/osci0203027s/:appFmId" element={<OSCI0203027S />} />
            {/* Contact person Modification !== 담당자 수정 ==! */}
            <Route path="/chpn/osci0203028s/:appFmId" element={<OSCI0203028S />} />

            {/* Contact person registration!== HS CODE 등록 ==! */}
            <Route path="/hscd/osci0203029s" element={<OSCI0203029S />} />
            {/* Contact person List !== HS CODE 목록 ==! */}
            <Route path="/hscd/osci0203030q" element={<OSCI0203030Q />} />
            {/* Contact person Detail !== HS CODE 상세 ==! */}
            <Route path="/hscd/osci0203031s/:appFmId" element={<OSCI0203031S />} />
            {/* Contact person Modification !== HS CODE 수정 ==! */}
            <Route path="/hscd/osci0203032s/:appFmId" element={<OSCI0203032S />} />
        </Routes>
    );
};
